var React = require('react');

function K2 (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"K2"),React.createElement("g",{"style":{"isolation":"isolate"},"key":1},[React.createElement("polygon",{"points":"24.46 53.19 59.22 0 0 8.03 3.58 34.42 24.46 53.19","fill":"#e5c83d","style":{"mixBlendMode":"multiply"},"key":0}),React.createElement("polygon",{"points":"3.63 17.32 3.63 85.06 34.99 85.06 66.2 85.06 3.63 17.32","fill":"#f47643","style":{"mixBlendMode":"multiply"},"key":1})])]);
}

K2.defaultProps = {"viewBox":"0 0 66.2 85.07"};

module.exports = K2;

K2.default = K2;
